import { snakeCase, isPlainObject } from 'lodash-unified';

const snakeCaseKeys = (obj: unknown): unknown => {
    if (isPlainObject(obj)) {
        return Object.entries(obj).reduce(
            (result, [key, value]) => {
                result[snakeCase(key)] = snakeCaseKeys(value);
                return result;
            },
            {} as Record<string, unknown>,
        );
    }
    if (Array.isArray(obj)) {
        return obj.map(snakeCaseKeys);
    }

    return obj;
};

export default snakeCaseKeys;
